import {
  AutoComplete,
  AutoCompleteItem
} from "@fidget/common/components/form/autoComplete/autoComplete";
import { ClickAwayListener } from "@fidget/common/components/form/clickAwayListener";
import React, { useState } from "react";

interface Props<Option> {
  options: Option[];
  placeholder: string;
  mapOptionToString: (option: Option | null) => string;
  onClose?: () => void;
  children: (helpers: CompoundDropdownHelpers<Option>) => JSX.Element;
  className?: string;
}
export const CompoundDropdown = function <Option extends AutoCompleteItem>(props: Props<Option>) {
  const { children, options, mapOptionToString, placeholder, onClose, className } = props;
  const [selectedOption, setSelectedOption] = useState<Option>();

  const renderOptionPicker = () => {
    return (
      <AutoComplete<Option>
        className={className}
        itemsProvider={() => options}
        itemToString={mapOptionToString}
        placeholder={placeholder}
        onChange={setSelectedOption}
        initialIsOpen
        readOnly
        onStateChange={(_, state) =>
          !state.selectedItem && !state.isOpen && onClose ? onClose() : undefined
        }
      />
    );
  };

  const renderChildren = (option: Option) => {
    return children({ selectedOption: option, reset: () => setSelectedOption(undefined) });
  };

  const render = () => {
    if (!selectedOption) {
      return renderOptionPicker();
    }

    return renderChildren(selectedOption);
  };

  if (onClose) {
    return <ClickAwayListener onClickAway={onClose}>{render()}</ClickAwayListener>;
  }

  return render();
};

export interface CompoundDropdownHelpers<Option> {
  selectedOption: Option;
  reset(): void;
}
